module.exports = __webpack_public_path__ + "img/ATIS_OLD.f98dd622.png";